import type { CsvValue } from "./csv.js";

function xml(value: CsvValue) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&apos;");
}

export function asExcelXml(sheetName: string, headers: string[], rows: CsvValue[][]) {
  const row = (values: CsvValue[], style = "Cell") =>
    `<Row>${values
      .map(
        (value) => `<Cell ss:StyleID="${style}"><Data ss:Type="String">${xml(value)}</Data></Cell>`,
      )
      .join("")}</Row>`;

  return `<?xml version="1.0" encoding="UTF-8"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:o="urn:schemas-microsoft-com:office:office"
 xmlns:x="urn:schemas-microsoft-com:office:excel"
 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
 <Styles>
  <Style ss:ID="Cell"><Alignment ss:Vertical="Center"/></Style>
  <Style ss:ID="Header"><Font ss:Bold="1"/><Interior ss:Color="#EAEAEA" ss:Pattern="Solid"/></Style>
 </Styles>
 <Worksheet ss:Name="${xml(sheetName)}"><Table>
  ${row(headers, "Header")}
  ${rows.map((values) => row(values)).join("\n  ")}
 </Table><WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel"><FreezePanes/><FrozenNoSplit/><SplitHorizontal>1</SplitHorizontal><TopRowBottomPane>1</TopRowBottomPane></WorksheetOptions></Worksheet>
</Workbook>`;
}

export function downloadExcel(
  filename: string,
  sheetName: string,
  headers: string[],
  rows: CsvValue[][],
) {
  const blob = new Blob([asExcelXml(sheetName, headers, rows)], {
    type: "application/vnd.ms-excel;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
